// extracted by mini-css-extract-plugin
export default {"root":"ExpertInsightsDetails_root__ojJtN"};